import tw from 'twin.macro';

export const Label = tw.label``;
